import './slide.scss';
import '../../img/fumes.webp';
import '../../img/all-that-is-needed.webp';
import '../../img/in-desert.webp';
import '../../img/in-the-forest.webp';
import '../../img/sunset.webp';
import '../../img/way-of-life.webp';
import '../../img/winter-has-come.webp';

import * as React from 'react';

import {Item} from '../mock-data';

interface Props {
  description: Item;
}

const Slide = (props: Props) => {
  const {src, title} = props.description;
  return (
    <div className="slide">
      <img src={src} alt={title} className="slide__image" width="300" height="200" />
      <h3 className="slide__title">{title}</h3>
    </div>
  );
};

export default Slide;
